module.exports = __webpack_public_path__ + "static/media/Squash_Niagara_Logo.bcb51180.png";